import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

const loadMaximumMaterialDiscountByRoleSelect = (data: any) => {
  return axios.get('/parameters/discount-max-mat-roles-to-select', data)
}

export function useLoadMaximumMaterialDiscountByRoleSelect(query: any) {
  return useQuery(
    ['maximumMaterialDiscountByRoleSelect', query],
    () => loadMaximumMaterialDiscountByRoleSelect(query),
    {
      onError: () =>
        toast.error(
          'Não foi possível carregar os perfis de valor de alçadas de desconto!',
          {
            toastId: 'loadMaximumMaterialDiscountByRoleSelect'
          }
        )
    }
  )
}
